/**
 * @generated SignedSource<<7f9301b72e88b5e3d7de826c29458284>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorePackageDetailFooter_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly id?: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useCustomerHasActiveOrUpcomingMembership_session" | "useIsUserSignedIn_session">;
  readonly " $fragmentType": "StorePackageDetailFooter_session";
};
export type StorePackageDetailFooter_session$key = {
  readonly " $data"?: StorePackageDetailFooter_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageDetailFooter_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorePackageDetailFooter_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsUserSignedIn_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCustomerHasActiveOrUpcomingMembership_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "50f9802b394604187e9ddcc5baf4cda1";

export default node;
